import z from 'zod'
import { amPointSchema } from 'src/common-services/types/alphamap/generic-types'
import { amGeometryPolygonSchema } from 'src/common-services/types/alphamap/geojson-types'

export const amLocationSearchNearestRequestSchema = z.object({
  latLng: amPointSchema,
  name: z.string().optional(),
  address: z.string().optional(),
  radius: z.number().max(10).positive().optional(),
  limit: z.number().max(1000).positive().optional(),
  skipSimilarity: z.boolean().optional(),
})

export type AMLocationSearchNearestRequest = z.infer<typeof amLocationSearchNearestRequestSchema>

export const amLocationShema = z.object({
  id: z.string(),
  name: z.string(),
  naicsCode: z.string(),
  isOpen: z.boolean(),
  street: z.string(),
  city: z.string(),
  state: z.string(),
  zipCode: z.string(),
  country: z.string(),
  latLng: amPointSchema,
  brandId: z.string().nullish().optional(),
  brandName: z.string().nullish().optional(),
  hasMobility: z.boolean().default(true).optional(),
})

export type AMLocation = z.infer<typeof amLocationShema>

export type AMBrandedLocation = AMLocation

export const amLocationScoredShema = amLocationShema.extend({
  score: z.number(),
  distance: z.number(),
})

export type AMLocationScored = z.infer<typeof amLocationScoredShema>

export const amLocationRequestSchema = z.object({
  id: z.string(),
})

export type AMLocationRequest = z.infer<typeof amLocationRequestSchema>

export const amLocationSearchPolygonRequestSchema = z.object({
  polygon: amGeometryPolygonSchema,
})

export type AMLocationSearchPolygonRequest = z.infer<typeof amLocationSearchPolygonRequestSchema>

export const amShoppingCenterPolygonRequestSchema = z.object({
  locationId: z.string(),
})

export type AMShoppingCenterPolygonRequest = z.infer<typeof amShoppingCenterPolygonRequestSchema>

// Location in Shopping Center
export const amMobilityShoppingCenterFromLocationSchema = amLocationShema.optional()
export type AMMobilityShoppingCenterFromLocation = z.infer<typeof amMobilityShoppingCenterFromLocationSchema>
